<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import NumberInput from "@/components/NumberInput";
import zip_codes from "@/data/zip_codes.json";
import state_gross from "@/data/state_gross_up.json";
import _ from "lodash";

import { new_api } from "../../auth_config.json";
export default {
  name: "step-app",
  components: {
    NumberInput,
    Multiselect,
  },
  props: ["byPass"],
  data() {
    return {
      grossOrNet: "gross",
      video: "",
      loginPage: true,
      cancelToken: undefined,
      netAmount: 0,
      checked: false,
      occupations: [],
      occupations_val: null,
      annual_gross_salary_level_val: 0,
      annual_gross_salary_level: [
        { text: "Low/Entry", value: 1 },
        { text: "Median", value: 2 },
        { text: "High/Experienced", value: 3 },
      ],
      forget_user_email: "",
      user_email: "",
      user_password: "",
      current_step: 1,
      income_method_val: false,
      max_step: 1,
      rentOrOwn: "",
      month_debs: "yes",
      moreIncome: "",
      healthInsurance: "no",
      numberOfPeople: "",
      age: "",
      zip: "",
      currentActiveAlphabet: "a",
      currentActiveNumber: 1,
      monthlyRent: 0,
      totalMonthly: 0,
      creditDebtPayment: null,
      studentLoan: null,
      alimonyPayments: null,
      homeEquityPayment: null,
      childSupportPayments: null,
      otherDebtPayments: null,
      healthPremiumAmount: null,
      homeIncomeAmount1: null,
      homeIncome: null,
      mainLogin: false,
      income_method: "2",
      incomes: [
        {
          amount: "",
          freq: 12,
          manual: "2",
          occupation: null,
          level: null,
          grossOrNet: "net",
          net: 0,
          gross: 0,
        },
      ],
      finalEmail: null,
      errorMsg: "",
      forgetMsg: "",
      clicked: false,
      tutorialtext: "Hide Video",
      hidetutorial: false,
      loggedUser: null,
      allowBypass: false,
      zip_codes: zip_codes,
      state_gross: state_gross,
      occupationGrossIncome: "0",
      occupationAIText: [],
      occupationAILoad: false
    };
  },

  methods: {
    async fillOccupationText(occupation) {
      const existingOccupation = this.incomes
        .filter((item) => item.manual === "1" && item.occupation)
        .map((item) => item.occupation);
      existingOccupation.push(occupation);
      const formData = new FormData();
      formData.append("req", existingOccupation);
      this.occupationAILoad = true;
      this.occupationAIText = [];
      const result = await this.$http.post(
        "https://admin.spendid.io/api/get-occupation-data",
        { req: existingOccupation }
      );
      // const jsonArray = JSON.parse(jsonString);
      this.occupationAILoad = false;
      this.occupationAIText = result.data.result;
    },
    incomeChange(key, manual) {
      const inc = _.cloneDeep(this.incomes);

      inc[key] = {
        amount: "",
        freq: 12,
        manual,
        occupation: null,
        level: null,
        grossOrNet: manual == "2" ? "net" : "gross",
        gross: 0,
        net: 0,
      };

      this.incomes = inc;
    },
    async levelChange(key, level, occupation, isOccupationChange = false) {
      if (occupation && level) {
        const selectedOccupation = this.occupations.find(
          (item) => item.id == occupation
        );
        let occ = null;

        if (level == 1) {
          occ = `${selectedOccupation.low.toFixed(0)}`;
        } else if (level == 2) {
          occ = `${selectedOccupation.median.toFixed(0)}`;
        } else if (level == 3) {
          occ = `${selectedOccupation.high.toFixed(0)}`;
        }
        const inc = _.cloneDeep(this.incomes);
        inc[key] = {
          amount: occ,
          freq: 1,
          manual: "1",
          occupation,
          grossOrNet: "gross",
          level: level,
          gross: parseInt(occ / 12),
          net: 0,
        };

        const url = "https://api.spendid.io/v1.0/calculators/net-income?gross=";
        const URI = `${url}${occ}&zip=${this.zip}`;
        const config = {
          headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        };
        const net = await this.$http.get(URI, config);
        inc[key] = {
          amount: occ,
          freq: 1,
          manual: "1",
          occupation,
          level: level,
          grossOrNet: "gross",
          gross: parseInt(occ / 12),
          net: net.data.net_annual_income / 12,
        };

        this.incomes = inc;
        const _this = this;
        setTimeout(() => {
          _this.$refs[`input_amount`][key].onBlur();
        }, 200);
      }
      if (isOccupationChange) {
        if (occupation) {
          this.fillOccupationText(occupation);
        } else {
          this.occupationAIText = [];
        }
      }
    },
    async getOccupation() {
      const URI = "https://api.spendid.io/v1.0/occupations";

      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      const occu = await this.$http.get(URI, config);
      this.occupations = occu.data.occupations;
    },
    avoidDecimal(value) {
      if (/[^0-9]+/.test(value)) return value.replace(/[^0-9]*/g, "");
      else return value;
    },
    onByPass() {
      this.$emit("stepEnable", false);
    },
    openForgetPopup() {
      this.$bvModal.show("forget-popup");
    },
    forgetNow() {
      this.forgetMsg = "";
      this.$http
        .post(`${new_api}/send-email-forget-password`, {
          email: this.forget_user_email,
        })
        .then((res) => {
          this.forgetMsg = "Check email for link to Reset Password";
          console.log(res);
        });
    },
    loginNow() {
      this.errorMsg = "";
      this.$http
        .post(`${new_api}/login`, {
          email: this.user_email,
          password: this.user_password,
        })
        .then((res) => {
          this.$cookies.set("userDetail", res.data, 0);
          window.dispatchEvent(
            new CustomEvent("loginEvent", {
              detail: res.data.data,
            })
          );
          location.reload();
          console.log(res);
          this.mainLogin = true;
          this.current_step = 1;

          let headers = {
            Authorization: "Bearer " + res.data.data.access_token,
          };
          this.$http
            .get(`${new_api}/get-last-data-By-user`, { headers })
            .then((response) => {
              if (response.data.data.budget) {
                this.allowBypass = true;
              }
            });
          // this.verifyEnable = false
          // this.verifyMsg = '<p class="text-success  text-center">Code sent to entered email.</p>'
        })
        .catch((err) => {
          console.log(err);
          this.errorMsg = "Invalid email or password*";
        });
    },
    async onSeourceSelect(i, input = true) {
      if (input) {
        this.$refs[`input_amount`][i].focus();
      }
      const self = this;
      // console.log(self.incomes[RegEx.exec(arg2)[1]].freq);
      setTimeout(async () => {
        const value = await this.recalculateNetAsync(
          this.incomes[i].amount * this.incomes[i].freq,
          this.incomes[i].grossOrNet
        );
        if (self.incomes[i].grossOrNet === "gross") {
          self.incomes[i].gross =
            (self.incomes[i].amount * self.incomes[i].freq) / 12;
          self.incomes[i].net = value;
        } else {
          self.incomes[i].net =
            (self.incomes[i].amount * self.incomes[i].freq) / 12;
          self.incomes[i].gross = value;
        }
      }, 500);
    },
    async recalculateNetAsync(amount, grossOrNet) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();
      const url =
        grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      return (
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12)
      );
    },
    incomeFinalStepBack() {
      if (this.healthInsurance === "yes") {
        this.current_step = 20;
      } else {
        this.current_step = 5;
      }
    },
    removeIncome(counter) {
      this.incomes.splice(counter, 1);
    },
    addIncomeNew() {
      const inc = this.incomes;
      inc.push({
        amount: "",
        freq: 12,
        manual: "2",
        occupation: null,
        level: null,
        grossOrNet: "gross",
        net: 0,
        gross: 0,
      });
      this.incomes = inc;
    },
    healthBack() {
      if (this.month_debs == "yes") {
        this.current_step = 14;
      } else {
        this.current_step = 8;
      }
    },
    incomeFinalStep() {
      this.current_step = 13;
    },
    enterEvent(type) {
      const _this = this;
      if (!this.$refs[type].disabled) {
        if (this.$refs[type].getAttribute("data-func")) {
          _this[this.$refs[type].getAttribute("data-func")]();
        } else {
          this.current_step = parseInt(
            this.$refs[type].getAttribute("data-step")
          );
        }
      }
    },
    mainSubmit() {
      const data = {
        current_step: this.current_step,
        rentOrOwn: this.rentOrOwn,
        month_debs: this.month_debs,
        moreIncome: this.moreIncome,
        healthInsurance: this.healthInsurance,
        numberOfPeople: this.numberOfPeople,
        age: this.age,
        zip: this.zip,
        currentActiveAlphabet: this.currentActiveAlphabet,
        monthlyRent: this.monthlyRent,
        totalMonthly: this.totalMonthly,
        creditDebtPayment: this.creditDebtPayment,
        studentLoan: this.studentLoan,
        alimonyPayments: this.alimonyPayments,
        homeEquityPayment: this.homeEquityPayment,
        childSupportPayments: this.childSupportPayments,
        otherDebtPayments: this.otherDebtPayments,
        healthPremiumAmount: this.healthPremiumAmount,
        homeIncomeAmount1: this.homeIncomeAmount1,
        homeIncome: this.homeIncome,
        grossOrNet: this.grossOrNet,
        incomes: this.incomes,
        finalEmail: this.user_email,
        annual_gross_salary_level_val: this.annual_gross_salary_level_val,
        occupations_val: this.occupations_val,
        income_method: this.income_method,
      };
      console.log(data);
      this.$emit("submitStepForm", data);
    },
    mainSubmit1() {
      const data = {
        current_step: this.current_step,
        rentOrOwn: this.rentOrOwn,
        month_debs: this.month_debs,
        moreIncome: this.moreIncome,
        healthInsurance: this.healthInsurance,
        numberOfPeople: this.numberOfPeople,
        age: this.age,
        zip: this.zip,
        currentActiveAlphabet: this.currentActiveAlphabet,
        monthlyRent: null,
        totalMonthly: this.totalMonthly,
        creditDebtPayment: this.creditDebtPayment,
        studentLoan: this.studentLoan,
        alimonyPayments: this.alimonyPayments,
        homeEquityPayment: this.homeEquityPayment,
        childSupportPayments: this.childSupportPayments,
        otherDebtPayments: this.otherDebtPayments,
        healthPremiumAmount: this.healthPremiumAmount,
        homeIncomeAmount1: this.homeIncomeAmount1,
        homeIncome: this.homeIncome,
        grossOrNet: this.grossOrNet,
        incomes: this.incomes,
        finalEmail: this.user_email,
      };
      this.$emit("submitStepForm", data);
    },
    addIncome() {
      const currentIncome = this.incomes;
      currentIncome.push({
        amount: this.homeIncomeAmount1,
        freq: parseInt(this.homeIncome),
      });
      this.incomes = currentIncome;

      if (this.moreIncome === "yes") {
        this.homeIncomeAmount1 = null;
        this.homeIncome = null;
        this.moreIncome = null;
        this.addMoreIncome();
        this.nextLetter(this.currentActiveAlphabet);
        this.current_step = 10;
      } else {
        this.current_step = 13;
      }
    },
    nextLetter(s) {
      this.currentActiveAlphabet = s.replace(
        /([a-zA-Z])[^a-zA-Z]*$/,
        function (a) {
          var c = a.charCodeAt(0);
          switch (c) {
            case 90:
              return "A";
            case 122:
              return "a";
            default:
              return String.fromCharCode(++c);
          }
        }
      );
    },
    studentLoanNext() {
      if (this.rentOrOwn == "own") {
        this.current_step = 17;
      } else {
        this.current_step = 16;
      }
    },
    addMoreIncome() {
      if (this.moreIncome == "yes") {
        this.current_step = 10;
      } else {
        this.current_step = 13;
      }
    },
    healthInsuranceNext() {
      if (this.healthInsurance == "yes") {
        this.current_step = 20;
      } else {
        this.healthPremiumAmount = 0;
        this.current_step = 10;
      }
    },
    anyOtherNext() {
      this.creditDebtPayment = null;
      this.studentLoan = null;
      this.alimonyPayments = null;
      this.homeEquityPayment = null;
      this.childSupportPayments = null;
      this.otherDebtPayments = null;
      if (this.month_debs == "yes") {
        this.current_step = 14;
      } else {
        this.mainSubmit();
      }
    },
    async numberValueChange2(arg, arg2) {
      const RegEx = /\[(.*?)\]/;
      var self = this;
      self.incomes[RegEx.exec(arg2)[1]].amount = arg;
      const value = await this.recalculateNetAsync(
        arg * self.incomes[RegEx.exec(arg2)[1]].freq,
        self.incomes[RegEx.exec(arg2)[1]].grossOrNet
      );
      console.log(value);
      if (self.incomes[RegEx.exec(arg2)[1]].grossOrNet === "gross") {
        self.incomes[RegEx.exec(arg2)[1]].gross =
          (arg * self.incomes[RegEx.exec(arg2)[1]].freq) / 12;
        self.incomes[RegEx.exec(arg2)[1]].net = value;
      } else {
        self.incomes[RegEx.exec(arg2)[1]].net =
          (arg * self.incomes[RegEx.exec(arg2)[1]].freq) / 12;
        self.incomes[RegEx.exec(arg2)[1]].gross = value;
      }
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
    },
    nextStep() {
      if (this.current_step < 104) {
        this.current_step = ++this.current_step;
      }
    },
    prevStep() {
      if (this.current_step > 2) {
        this.current_step = --this.current_step;
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    tutorialtorage() {
      this.hidetutorial = true;
      localStorage.setItem("hideTutorial", "false");
    },
    async recalculateNet(amount) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();

      const url =
        this.grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount * 12}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      this.netAmount =
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12);
    },
  },
  computed: {
    zipCity() {
      const matchingZip = this.zip_codes.find(
        (item) => item["Zip Code"] === this.zip
      );
      return matchingZip ? matchingZip.City : "";
    },
    zipState() {
      const matchingZip = this.zip_codes.find(
        (item) => item["Zip Code"] === this.zip
      );
      if (matchingZip) {
        const matchingState = this.state_gross.find(
          (it) => it.abbreviation === matchingZip.State
        );
        if (matchingState) {
          return matchingState.state;
        }
      }
      return "";
    },
    checkStoredValue() {
      var storedData = localStorage.getItem("storedData");
      if (storedData) {
        storedData = JSON.parse(storedData);
        if (storedData.zip) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    occupationGrossIncomeFormat() {
      const sum = this.occupationGrossIncome;
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      if (isNaN(Math.round(sum))) {
        return "$0";
      }
      return formatter.format(Math.round(sum));
    },
    firstSession() {
      return localStorage.getItem("firstSession")
        ? localStorage.getItem("firstSession") == "1"
        : false;
    },
    userName() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.name
          : null) || this.data
      );
    },
    userId() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.id
          : null) || this.data
      );
    },
    returnUser() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    },
    getCookies() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    },
    otherAllDebs() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      const sum = [
        this.creditDebtPayment,
        this.studentLoan,
        this.otherDebtPayments,
      ]
        .filter(Boolean)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0);
      return formatter.format(sum);
    },
    monthly_take_home_input_value() {
      const sum = this.incomes.reduce(
        (partialSum, a) => partialSum + parseFloat(a.gross || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    netAmountInput() {
      const sum = this.incomes.reduce(
        (partialSum, a) => partialSum + parseFloat(a.net || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    monthly_take_home_input_value_int() {
      const sum = this.incomes.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(a.gross || 0) * parseInt(a.freq || 0),
        0
      );
      // this.recalculateNet(Math.round(sum / 12));
      return Math.round(sum / 12);
    },
  },
  watch: {
    income_method_val(val) {
      this.incomes = [
        {
          amount: "0",
          freq: 12,
        },
      ];
    },
    occupations_val: {
      handler(val) {
        if (val && this.annual_gross_salary_level_val) {
          const selectedOccupation = this.occupations.find(
            (item) => item.id == val
          );
          if (this.annual_gross_salary_level_val == 1) {
            this.occupationGrossIncome = selectedOccupation.low;
            this.incomes = [
              {
                amount: `${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.incomes = [
              {
                amount: `${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.incomes = [
              {
                amount: `${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }
        }
      },
      deep: true,
      immediate: true,
    },
    annual_gross_salary_level_val(val) {
      if (this.occupations_val) {
        const selectedOccupation = this.occupations.find(
          (item) => item.id == this.occupations_val
        );
        if (val == 1) {
          console.log(selectedOccupation.low, "1");
          this.occupationGrossIncome = selectedOccupation.low;
          this.incomes = [
            {
              amount: `${selectedOccupation.low}`,
              freq: 1,
            },
          ];
        } else if (val == 2) {
          this.occupationGrossIncome = selectedOccupation.median;
          this.incomes = [
            {
              amount: `${selectedOccupation.median}`,
              freq: 1,
            },
          ];
        } else if (val == 3) {
          this.occupationGrossIncome = selectedOccupation.high;
          this.incomes = [
            {
              amount: `${selectedOccupation.high}`,
              freq: 1,
            },
          ];
        }
      }
    },
    grossOrNet() {
      const sum = this.incomes.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(a.amount || 0) * parseInt(a.freq || 0),
        0
      );
      this.recalculateNet(Math.round(sum / 12));
    },
    current_step(value) {
      window.scrollTo(0, 0);
      this.max_step = value > this.max_step ? value : this.max_step;
      if ([2, 3, 6, 7, 14, 20, 13].includes(value)) {
        setTimeout(() => {
          this.$refs[`field_${value}`].focus();
        }, 200);
      }
    },
    byPass: {
      handler(value) {
        this.byPass = value;
      },
      deep: true,
    },
    numberOfPeople(val) {
      if (val) {
        setTimeout(() => {
          this.current_step = 5;
        }, 300);
      }
    },
    rentOrOwn(val) {
      if (val) {
        setTimeout(() => {
          this.current_step = 6;
        }, 300);
      }
    },
    month_debs(val) {
      if (val) {
        setTimeout(() => {
          this.anyOtherNext();
        }, 300);
      }
    },
    healthInsurance(val) {
      if (val) {
        setTimeout(() => {
          this.healthInsuranceNext();
        }, 300);
      }
    },
    homeIncome(val) {
      if (val) {
        this.$refs.takeHome.focus();
      }
    },
    moreIncome(val) {
      if (val) {
        setTimeout(() => {
          this.addIncome();
        }, 300);
      }
    },
  },
  mounted() {
    this.hidetutorial = localStorage.getItem("hideTutorial")
      ? localStorage.getItem("hideTutorial") === "false"
      : false;
    this.getOccupation();
  },
  created() {
    // if(this.getCookies.access_token){
    //      let headers = {
    //         'Authorization': 'Bearer '+this.getCookies.access_token
    //     };
    //     this.$http.get(`${new_api}/get-last-data-By-user`,{headers}).then((response) => {
    //         if(response.data.data.budget){
    //             this.allowBypass = true
    //         }
    //     })
    // }
  },
};
</script>

<template>
  <div class="step_form_area" :class="{ 'side-visible': !(!returnUser && !mainLogin) }">
    <div class="interview-customer-logo">
      <img alt="logo" src="spendid-logo.png" />
    </div>
    <b-container>
      <div class="logo_area w-100 d-none">
        <img src="logo-spendid-circle.png" />
      </div>

      <div class="step-p">
        <div class="progress_data w-100" :class="{ 'd-none': current_step == 1 }">
          <ul>
            <li :class="{
              active: current_step == 2,
              max_active: this.max_step >= 2,
            }">
              <a href="#" @click="current_step = 2">
                <div><img src="zip-ico.png" /></div>
                <span>Zip Code</span>
              </a>
            </li>
            <li :class="{
              active: current_step == 3,
              max_active: this.max_step >= 3,
            }">
              <a href="#" @click="current_step = 3">
                <div><img src="age-ico2.png" /></div>
                <span>Age</span>
              </a>
            </li>
            <li :class="{
              active: current_step == 4,
              max_active: this.max_step >= 4,
            }">
              <a href="#" @click="current_step = 4">
                <div><img src="house-ico.png" /></div>
                <span>Household</span>
              </a>
            </li>
            <li :class="{
              active: current_step == 5,
              max_active: this.max_step >= 5,
            }">
              <a href="#" @click="current_step = 5">
                <div><img src="home-ico.png" /></div>
                <span>Home Type</span>
              </a>
            </li>
            <li :class="{
              active: current_step == 6,
              max_active: this.max_step >= 6,
            }">
              <a href="#" @click="current_step = 6">
                <div><img src="income-ico.png" /></div>
                <span>Income $</span>
              </a>
            </li>
            <li :class="{
              active: current_step == 8 || current_step == 14,
              max_active: this.max_step >= 8 || this.max_step == 14,
            }">
              <a href="#" @click="current_step = 8">
                <div><img src="obligation-ico.png" /></div>
                <span>Obligations</span>
              </a>
            </li>
            <!-- <li :class="{'active': current_step==13}"><a href="#" @click="current_step>13 ? current_step=13: null"><div><img src="email-ico.png" /></div><span>Email</span></a></li> -->
          </ul>
        </div>
      </div>
    </b-container>

    <div class="d-lg-block custom-switch-step-style" onClick="bodyClassAdd2()">
      <b-form-checkbox class="mr-2 d-lg-inline-block" id="darkLightChange2" @change="$parent.changeMode($event)"
        v-model="checked" name="check-button" switch>
        Light/Dark
      </b-form-checkbox>
    </div>
    <b-container id="cash-flow-score">
      <b-row ref="step-form">
        <div class="form_block_area w-100">
          <!-- question start -->
          <div id="app_steps" class="w-100">
            <form class="w-100">
              <b-col md="12" class="text-center createprofile-step" :class="{ 'd-none': current_step != 1 }" id="step1">
                <!-- <div v-if="returnUser" class="acount-profile-wrap">
                  <a
                    class="profile_icon"
                    href="https://business.spendid.io/dashboard"
                  >
                    <img
                      :src="
                        `https://business.spendid.io/api/get-image/${userId}?ver=${Math.random()}`
                      "
                      width="50"
                    />
                    <p class="profile_name">{{ userName }}</p>
                  </a>
                </div> -->
                <b-col v-if="!returnUser && !mainLogin" md="12">
                  <!-- <b-link  class="backhome" target="_blank" href="https://spendid.io/">Back to Home</b-link> -->
                  <!-- <b-link  class="backhome" target="_blank" href="https://www.mybudgetreport.com/">Back to Home</b-link> -->
                </b-col>
                <b-col md="12" class="p-0 mobileisize mt-lg-3">
                  <!-- <b-col md="12" class="text-center time_duration mt-4 mb-4 p-0 " >
                                        <div>
                                            <p style="font-size: 26px;">Stick it to "Financial Adulting"</p>
                                            <p style="font-size: 16px;">
                                                <span style="color:rgb(58, 183, 164)">SPENDiD Collegiate</span> uses proven peer spending behavior data to help you easily understand what your life will likely cost, where you choose to live it.
                                            </p>
                                            <p style="font-size: 16px;">
                                                <span style="color:rgb(58, 183, 164)">The Result:</span> Confidence to make smart budget decisions, avoid debt and grow savings.
                                            </p>
                                        </div>
                                    </b-col> -->
                  <img width="200" src="brown-logo.png" />
                </b-col>
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->

                <template>
                  <b-col md="12" class="position-relative p-0">
                    <!-- <b-col md="12" class="text-center mb-4 mt-3 p-0">
                      <a
                        role="button"
                        href="https://gradbudget.com/instructions"
                      >
                        <button type="button" class="cta btn-sm">
                          Instructions
                        </button>
                      </a>
                    </b-col> -->
                    <b-col md="12" class="text-center time_duration mb-4 mt-2 mt-lg-4 p-0" style="font-size: 26px">
                      Create Your Profile
                    </b-col>

                    <div class="instruction-tooltip">
                      <b-button @click="
                        (current_step = 2),
                        (clicked = clicked = true),
                        (tutorialtext = clicked
                          ? 'Watch Onboard Tutorial'
                          : 'Hide Video')
                        " type="button" class="cta">Start</b-button>
                      <div class="hover-info-box">
                        <span class="hover-icon">
                          <i class="far fa-question-circle fa-2x"></i>
                        </span>
                        <div class="hover-info position-right">
                          <p class="m-0 hover-info-text">
                            Click <b>START</b> and answer a few simple prompts
                            to create a <b>Peer Profile</b> and a starting point
                            budget in minutes.
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- <span class="press">Press Enter ↵</span> -->
                  </b-col>

                  <b-col md="12" v-if="firstSession" class="time_duration end mt-4 p-0">
                    <!-- <small class="text-capitalize"
                      >Got to app the Onboarding Interview and go directly to
                      the App, click here:</small
                    > -->
                    <div class="instruction-tooltip" v-if="checkStoredValue">
                      <b-button @click="onByPass" type="button" class="cta ml-2 btn-sm">Go to App
                      </b-button>
                      <div class="hover-info-box">
                        <span class="hover-icon">
                          <i class="far fa-question-circle fa-2x"></i>
                        </span>
                        <div class="hover-info position-right">
                          <p class="m-0 hover-info-text">
                            To skip the Interview and use your previously stored
                            data, <br />click
                            <span class="text-uppercase"><b>Go to app</b></span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </template>
              </b-col>

              <!-- <div class="tutorial_bg" :class="{ toggle: clicked }">
                                <b-button class="onboardhide" @click="clicked = !clicked, tutorialtext= clicked? 'Watch Onboard Tutorial' : 'Hide Video'">{{tutorialtext}}</b-button>
                                <div class="fixedtutorial_bg" >
                                    <iframe style="height:415px" class="onboard" width="560" src="https://www.youtube.com/embed/9imNXX58YZw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </div> -->

              <b-col md="12" class="question_answer disable-animation-effect" :class="{ 'd-none': current_step != 2 }"
                id="step2">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>1</span>
                  <h5 class="text-capitalize">
                    5-digit Home Zip Code where you plan to live
                  </h5>
                </div>
                <div class="position-relative">
                  <b-form-input placeholder="Type your answer here..." v-model="zip" pattern="\d*" ref="field_2"
                    @keydown.enter.native="enterEvent('zip')" v-on:keypress="NumbersOnly" type="text" maxlength="5"
                    autocomplete="on" class="position-relative" :formatter="avoidDecimal">
                  </b-form-input>
                  <div class="city-state">
                    <div>{{ zipCity }}</div>
                    <div>{{ zipState }}</div>
                  </div>
                </div>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <b-button type="button" @click="current_step = 3" data-step="3" ref="zip" :disabled="zip.length < 5 ||
                    !zip_codes.find((item) => item['Zip Code'] === zip)
                    " class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button>
                  <span class="press">Press Enter ↵</span>
                </b-col>
                <b-col class="back_button">
                  <b-button @click="current_step = 1" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 3" :disabled="zip.length < 5 ||
                    !zip_codes.find((item) => item['Zip Code'] === zip)
                    " class="cta cta_icons"><i class="fa fa-angle-right"></i></b-button>
                </b-col>

                <b-col md="12">
                  <div class="tutorial_bg" v-if="!hidetutorial">
                    <!-- <b-button class="onboardhide" @click="tutorialtorage()">Hide Video</b-button>
                                    <div class="fixedtutorial_bg" >
                                        <iframe style="height:415px" class="onboard" width="560" src="https://www.youtube.com/embed/9imNXX58YZw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div> -->
                  </div>
                </b-col>
              </b-col>

              <b-col md="12" class="mb-4 mt-3 question_answer disable-animation-effect"
                :class="{ 'd-none': current_step != 3 }" id="step3">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>2</span>
                  <h5 class="">
                    <span class=""></span> Age In This Scenario (Must be 18+)
                    <!-- <p>(Scenarios valid for 18 or older)</p> -->
                  </h5>
                </div>
                <b-form-input placeholder="Type your answer here..." v-model="age" type="text" ref="field_3"
                  pattern="\d*" @keydown.enter.native="enterEvent('age')" v-on:keypress="NumbersOnly" maxlength="3"
                  autocomplete="on" :formatter="avoidDecimal" class="position-relative">
                </b-form-input>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <b-button type="button" @click="current_step = 4" data-step="4" ref="age" :disabled="age < 18"
                    class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button>
                  <span class="press">Press Enter ↵</span>
                </b-col>

                <b-col class="back_button">
                  <b-button @click="current_step = 2" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 4" :disabled="age < 18" class="cta cta_icons"><i
                      class="fa fa-angle-right"></i></b-button>
                </b-col>
              </b-col>

              <b-col md="12" class="mb-4 mt-3 question_answer disable-animation-effect"
                :class="{ 'd-none': current_step != 4 }" id="step4">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>3</span>
                  <h5 class="text-capitalize">Number of People in Household</h5>
                </div>
                <div class="radio_part">
                  <label class="radio_label">
                    <input type="radio" value="1" v-model="numberOfPeople" name="numberOfPeople" />
                    <span>A</span>
                    <p>1</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="2" v-model="numberOfPeople" name="numberOfPeople" />
                    <span>B</span>
                    <p>2</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="3" v-model="numberOfPeople" name="numberOfPeople" />
                    <span>C</span>
                    <p>3</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="4" v-model="numberOfPeople" name="numberOfPeople" />
                    <span>D</span>
                    <p>4</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="5" v-model="numberOfPeople" name="numberOfPeople" />
                    <span>E</span>
                    <p>5 or more</p>
                  </label>
                </div>
                <!-- <b-col md="12" class="mt-4 p-0 position-relative">
                                    <b-button type="button" @click="current_step=5" :disabled="!numberOfPeople" class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button>
                                </b-col> -->
                <b-col class="back_button">
                  <b-button @click="current_step = 3" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 5" :disabled="!numberOfPeople" class="cta cta_icons"><i
                      class="fa fa-angle-right"></i></b-button>
                </b-col>
              </b-col>

              <b-col md="12" class="mb-4 mt-3 question_answer disable-animation-effect"
                :class="{ 'd-none': current_step != 5 }" id="step5">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>4</span>
                  <h5 class="text-capitalize">
                    Will You Rent or Buy Your Home?
                  </h5>
                </div>
                <div class="radio_part">
                  <label class="radio_label">
                    <input type="radio" value="rent" v-model="rentOrOwn" name="rentOrOwn" />
                    <span>A</span>
                    <p>Rent</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="own" v-model="rentOrOwn" name="rentOrOwn" />
                    <span>B</span>
                    <p>Buy</p>
                  </label>
                </div>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <!-- <b-button type="button" @click="current_step=6" :disabled="!rentOrOwn"  class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button> -->
                </b-col>
                <b-col class="back_button">
                  <b-button @click="current_step = 4" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 6" :disabled="!rentOrOwn" class="cta cta_icons"><i
                      class="fa fa-angle-right"></i></b-button>
                </b-col>
              </b-col>

              <b-col md="12" class="mb-4 mt-3 question_answer disable-animation-effect"
                :class="{ 'd-none': current_step != 14 }" id="step8">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>6</span>
                  <h5 class="text-capitalize">
                    Will you have Other Monthly Debt Payments?
                  </h5>
                </div>
                <div class="radio_part">
                  <label class="radio_label">
                    <input type="radio" value="yes" v-model="month_debs" name="obligationPayments" />
                    <span>A</span>
                    <p>Yes</p>
                  </label>
                  <label class="radio_label">
                    <input type="radio" value="no" v-model="month_debs" name="obligationPayments" />
                    <span>B</span>
                    <p>No</p>
                  </label>
                </div>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <!-- <b-button type="button" @click="anyOtherNext()" :disabled="!month_debs" class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button> -->
                </b-col>
                <b-col class="back_button">
                  <b-button @click="current_step = 6" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 14" :disabled="!month_debs || month_debs == 'no'"
                    class="cta cta_icons"><i class="fa fa-angle-right"></i></b-button>
                </b-col>
              </b-col>

              <!-- yes click start-->
              <b-col md="12" class="mb-4 mt-3 question_answer animation_disable combine_questions"
                :class="{ 'd-none': current_step != 8 }" id="step14">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>6</span>
                  <h5 class="text-capitalize">
                    Enter <u>Monthly Payment Amounts</u> For
                  </h5>
                </div>
                <h3 class="text-right d-none d-md-block">
                  <u>Monthly Payment:</u>
                </h3>
                <ul class="debt-list">
                  <li>
                    <span class="past-credit text-capitalize">
                      Past Credit Card Debt
                      <i>(exclude new monthly charges you pay in full each
                        month)</i>
                    </span>
                    <div class="width-400">
                      <NumberInput ref="field_14" :model="creditDebtPayment"
                        v-on:enterEvent="enterEvent('creditDebtPayment')" @changeValue="numberValueChange"
                        name="creditDebtPayment" placeholder="$0" />
                    </div>
                  </li>
                  <li>
                    <span class="text-capitalize"> Student Loans </span>
                    <div class="width-400">
                      <NumberInput :model="studentLoan" v-on:enterEvent="enterEvent('creditDebtPayment')"
                        @changeValue="numberValueChange" name="studentLoan" placeholder="$0" />
                    </div>
                  </li>

                  <li>
                    <span class="past-credit text-capitalize">
                      Other Debt Payments
                      <i>(<u>Excluding</u> Mortgage and Car Payments)</i>
                    </span>
                    <div class="width-400">
                      <NumberInput :model="otherDebtPayments" v-on:enterEvent="enterEvent('creditDebtPayment')"
                        @changeValue="numberValueChange" name="otherDebtPayments" placeholder="$0" />
                    </div>
                  </li>
                  <li class="pt-2 mt-2 total-amout wrap justify-content-end">
                    <div class="not-applicable d-block text-right">
                      or Leave at zero if not applicable
                    </div>
                  </li>
                  <li class="pt-4 mt-4 total-amout wrap">
                    <span class="total-amount text-capitalize"> Total </span>
                    <div class="width-400">
                      <span>{{ otherAllDebs }}</span>
                    </div>
                  </li>
                </ul>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <b-button type="button" @click="mainSubmit()" data-func="mainSubmit" ref="creditDebtPayment"
                    class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button>
                  <span class="press">Press Enter ↵</span>
                </b-col>
                <b-col class="back_button">
                  <b-button @click="current_step = 6" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <!-- <b-button type="button" @click="current_step=10"  class="cta cta_icons"><i class="fa fa-angle-right"></i></b-button> -->
                </b-col>
              </b-col>
              <!-- yes click end -->

              <b-col md="12" class="mb-3 question_answer combine_questions disable-animation-effect"
                :class="{ 'd-none': current_step != 6 }" id="step10">
                <div class="question">
                  <span>5</span>
                  <h5 class="text-capitalize">Income</h5>
                </div>

                <!-- <input type="radio" v-model="grossOrNet" value="gross">
                                <input type="radio" v-model="grossOrNet" value="net"> -->

                <div class="steps-body">
                  <div class="income-method-inner row">
                    <b-col cols="12" md="12" sm="12">
                      <b-row class="align-items-stretch justify-content-center">
                        <b-col cols="12" md="12" sm="12"
                          :lg="(occupationAIText.length > 0 || occupationAILoad) ? '6' : '12'">
                          <b-row class="align-items-stretch justify-content-center">
                            <div v-for="(income, i) in incomes" :key="i" md="12" lg="3"
                              class="result-profile-innercard profile-innercard no-box-shadow border-0 bg-transparent p-2 p-lg-3"
                              :style="(occupationAIText.length > 0 || occupationAILoad) ? 'width:50%' : 'width:25%'">
                              <template>
                                <div class="home_income">
                                  <div class="tagline mb-2 mb-lg-3 d-flex justify-space-between align-items-center">
                                    <div class="source-count">
                                      <span class="d-inline-block text-source">
                                        Source #{{ i + 1 }}
                                      </span>
                                      <span class="ml-2 d-inline-block text-frequency">
                                        (Frequency)
                                      </span>
                                    </div>
                                    <div class="d-flex justify-space-between align-items-center">
                                      <span v-if="incomes.length > 1" @click="removeIncome(i)"
                                        class="text-danger cursor-pointer far fa-times-circle"></span>
                                    </div>
                                  </div>
                                  <div
                                    class="income-method-type mb-3 flex-md-row flex-sm-row flex-lg-column flex-xl-column justify-space-between align-items-center">
                                    <div class="inputGroup my-1">
                                      <input type="radio" :name="`income_method_${i}`" class="custom-control-input"
                                        value="1" @change="incomeChange(i, incomes[i].manual)"
                                        v-model="incomes[i].manual" :id="`incomeradioOption${i}`" />
                                      <label :for="`incomeradioOption${i}`">
                                        <span class="">Occupation</span>
                                      </label>
                                    </div>
                                    <div class="inputGroup my-1">
                                      <input type="radio" :name="`income_method_${i}`" class="custom-control-input"
                                        value="2" @change="incomeChange(i, incomes[i].manual)"
                                        v-model="incomes[i].manual" :id="`grossradioOption${i}`" />
                                      <label :for="`grossradioOption${i}`">
                                        <span class="">Manual Input</span>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="manually-input-radios">
                                    <template v-if="income.manual == '2'">
                                      <div class="manually-inputGroup-radios">
                                        <div class="inputGroup mb-1">
                                          <input :id="`weeklyRadio-${i}`" type="radio" value="52"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <!-- <span>A</span> -->
                                          <label :for="`weeklyRadio-${i}`">
                                            Weekly
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`2weekRadio-${i}`" type="radio" value="26"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`2weekRadio-${i}`">
                                            <!-- <span>B</span> -->
                                            Every 2 Weeks
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`permonthRadio-${i}`" type="radio" value="24"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`permonthRadio-${i}`">
                                            <!-- <span>C</span> -->
                                            Twice Per Month
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`MonthlyRadio-${i}`" type="radio" value="12"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`MonthlyRadio-${i}`">
                                            <!-- <span>D</span> -->
                                            Monthly
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`quarterlyRadio-${i}`" type="radio" value="4"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`quarterlyRadio-${i}`">
                                            <!-- <span>E</span> -->
                                            Quarterly
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`semiannuallyRadio-${i}`" type="radio" value="2"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`semiannuallyRadio-${i}`">
                                            <!-- <span>F</span> -->
                                            Semi-Annually
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-1">
                                          <input :id="`annuallyRadio-${i}`" type="radio" value="1"
                                            @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                            :name="`incomes[${i}].freq`" />
                                          <label :for="`annuallyRadio-${i}`">
                                            <!-- <span>G</span> -->
                                            Annually
                                          </label>
                                        </div>
                                      </div>
                                      <div class="amount_data mt-3">
                                        <b-form-group class="custom-form-control mb-0" label="Amount">
                                          <NumberInput :model="incomes[i].amount" ref="input_amount"
                                            v-on:enterEvent="enterEvent('finalEmail')" @changeValue="numberValueChange2"
                                            :name="`incomes[${i}].amount`" placeholder="Type your answer here..." />
                                        </b-form-group>
                                      </div>

                                      <div class="gross-net-home-radios mt-2">
                                        <div class="inputGroup mb-2">
                                          <input type="radio" :name="`radio-inline-${i}`" value="gross"
                                            @click="onSeourceSelect(i, false)" v-model="incomes[i].grossOrNet"
                                            :id="`incomeradioOption-${i}`" />
                                          <label :for="`incomeradioOption-${i}`">
                                            <span class="">Gross</span>
                                          </label>
                                        </div>
                                        <div class="inputGroup mb-2">
                                          <input type="radio" :name="`radio-inline-${i}`" value="net"
                                            @click="onSeourceSelect(i, false)" v-model="incomes[i].grossOrNet"
                                            :id="`grossradioOption-${i}`" />
                                          <label :for="`grossradioOption-${i}`">
                                            Net "Take Home"
                                          </label>
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <b-row>
                                        <b-col md="12" lg="12">
                                          <b-form-group class="mb-lg-4 mt-2 custom-form-control"
                                            label="Occupation Selector">
                                            <Multiselect placeholder="Search" v-model="incomes[i].occupation" @select="
                                              levelChange(
                                                i,
                                                incomes[i].level,
                                                incomes[i].occupation,
                                                true
                                              )
                                              " :options="occupations.map((item) => item.id)
                                                ">
                                            </Multiselect>
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-form-group class="mb-lg-4 custom-form-control"
                                        label="Annual Gross Salary Level">
                                        <b-row>
                                          <b-col md="12">
                                            <b-form-radio-group :disabled="!incomes[i].occupation"
                                              v-model="incomes[i].level" :options="annual_gross_salary_level" @change="
                                                levelChange(
                                                  i,
                                                  incomes[i].level,
                                                  incomes[i].occupation,
                                                  true
                                                )
                                                " :name="`radio-inline-${i}`"
                                              class="custom-form-control annual-gross-level-radios"
                                              stacked></b-form-radio-group>
                                          </b-col>
                                        </b-row>
                                      </b-form-group>
                                      <b-row>
                                        <b-col md="12" lg="12" class="annual-gross-input mt-lg-4">
                                          <b-form-group class="custom-form-control mb-0 mt-lg-4"
                                            label="Amount(Annual Gross)">
                                            <NumberInput :model="incomes[i].amount" ref="input_amount"
                                              @changeValue="numberValueChange2" disabled :name="`incomes[${i}].amount`"
                                              placeholder="Type your answer here..." />
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                    </template>
                                  </div>
                                </div>
                              </template>
                            </div>
                            <b-col md="12" lg="3" class="mb-3 mb-lg-0">
                              <div v-if="incomes.length < 4" class="add_home_income h-100">
                                <div class="tagline mb-2 mb-lg-3 d-flex justify-space-between align-items-center">
                                  <div class="source-count">
                                    <span class="d-inline-block text-source">
                                      Source #{{ incomes.length + 1 }}
                                    </span>
                                    <span class="ml-2 d-inline-block text-frequency">
                                      (Frequency)
                                    </span>
                                  </div>
                                  <div class="d-flex justify-space-between align-items-center"></div>
                                </div>
                                <b-card no-header
                                  class="no-box-shadow add-income-source-card income-method-inner-card border-radius-10">
                                  <div class="add-income-source h-100">
                                    <!-- <h4
                                        class="d-block d-md-none text-center text-capitalize"
                                      >
                                        Add Income Source
                                      </h4> -->
                                    <div @click="addIncomeNew()" class="add_more_data">
                                      <i class="fa fa-plus flex-shrink-0 mr-2 mr-md-0"></i>
                                      <h6 class="mb-0 mt-0 mt-md-2">Add More</h6>
                                    </div>
                                  </div>
                                </b-card>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col cols="12" md="12" :lg="(occupationAIText.length > 0 || occupationAILoad) ? '6' : '12'">
                          <div v-if="!occupationAILoad"
                            class="bg-transparent ai-response-profile-card-outer ai-overflow-y d-flex">
                            <b-card no-header no-body
                              class="ai-response-profile-card no-box-shadow border-radius-10 border-radius-10 mb-3 mr-2"
                              v-for="(aidata, i) in occupationAIText" :key="i">
                              <div class="ai-response-profile-card-header">
                                <h2>{{ aidata.title }}</h2>
                              </div>
                              <div class="ai-response-profile-card-body">
                                <div class="ai-response-profile-card-body-content"
                                  v-for="(insights, j) in aidata.detail" :key="j">
                                  <h3>{{ insights.title }}</h3>
                                  <ul class="ai-response-profile-list mt-2">
                                    <li>
                                      {{ insights.detail }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </b-card>
                          </div>
                          <b-card v-else no-header no-body
                            class="ai-response-profile-card no-box-shadow border-radius-10 mb-3 d-none d-md-block">
                            <div class="ai-response-profile-card-body ai-response-min-height">
                              <div class="text-center w-100 ai-response-min-height">
                                <div
                                  class="d-flex flex-column align-items-center justify-content-center ai-response-min-height">
                                  <div class="loader-ai"></div>
                                  <p class="mb-0 mt-2">
                                    Loading, Please Wait...
                                  </p>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-card no-header
                            class="no-box-shadow monthly-gross-income-inner-card mb-3 mt-0 mt-lg-5 border-radius-10">
                            <b-row>
                              <!-- <b-col cols="12" md="12" lg="3"> </b-col> -->
                              <b-col col="12" md="12" lg="12">
                                <template v-if="grossOrNet === 'gross'">
                                  <div class="total_monthly_inc text-capitalize">
                                    Total Monthly Gross Income
                                    <span class="income-amount">{{
                                      monthly_take_home_input_value
                                      }}</span>
                                  </div>
                                  <div class="total_monthly_inc mt-1 text-capitalize">
                                    Estimated Monthly Take-Home Income
                                    <span class="income-amount">{{
                                      netAmountInput
                                      }}</span>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="total_monthly_inc text-capitalize">
                                    Estimated Monthly Gross Income
                                    <span class="income-amount">{{
                                      netAmountInput
                                      }}</span>
                                  </div>
                                  <div class="total_monthly_inc mt-1 text-capitalize">
                                    Total Monthly Take-Home Income
                                    <span class="income-amount">{{
                                      monthly_take_home_input_value
                                      }}</span>
                                  </div>
                                </template>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-col>
                  </div>

                </div>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <b-button @click="current_step = 8" :disabled="!monthly_take_home_input_value_int > 0" data-step="8"
                    ref="finalEmail" type="button" class="cta cta_icons">OK <i class="fa fa-check ml-1"></i></b-button>
                  <span class="press">Press Enter ↵</span>
                </b-col>
                <b-col class="back_button">
                  <b-button @click="incomeFinalStepBack()" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                  <b-button type="button" @click="current_step = 8" :disabled="!monthly_take_home_input_value_int > 0"
                    class="cta cta_icons"><i class="fa fa-angle-right"></i></b-button>
                </b-col>
              </b-col>

              <b-col md="12" class="mb-4 mt-3 question_answer disable-animation-effect"
                :class="{ 'd-none': current_step != 13 }" id="step13">
                <!-- <div class="interview-customer-logo">
                  <img alt="logo" src="brown-logo.png" />
                </div> -->
                <div class="question mb-4">
                  <span>9</span>
                  <h5 class="text-capitalize">
                    Enter Your Assessment Name
                    <p>
                      (Next we'll take you to the app where you can customize
                      anything else you'd like and see your Results.)
                    </p>
                  </h5>
                </div>
                <b-form-input placeholder="Type your answer here..." type="text" ref="field_13"
                  @keydown.enter.native="('finalEmail')" v-model="finalEmail" autocomplete="on">
                </b-form-input>
                <b-col md="12" class="mt-4 p-0 position-relative">
                  <!-- <b-button type="button" @click="mainSubmit()"  data-func="mainSubmit" ref="finalEmail" class="cta cta_icons" :disabled="!finalEmail">submit</b-button> -->
                  <span class="press ml-3">Press Enter ↵</span>
                </b-col>
                <b-col md="12" class="mt-4 p-0 position-relative"> </b-col>
                <b-col class="back_button">
                  <!-- <b-button type="button" @click="mainSubmit1()" class="cta cta_icons">Skip</b-button> -->
                  <b-button @click="current_step = 10" type="button" class="cta cta_icons"><i
                      class="fa fa-angle-left"></i></b-button>
                </b-col>
              </b-col>
            </form>
          </div>
          <!-- question end -->
          <!-- 
                        <div class="prev_next w-100" :class="{'d-none': current_step == 1}">
                            <button @click="prevStep()" :class="{'disabled': current_step==2}"><i class="fa fa-angle-up"></i></button>
                            <button @click="nextStep()" :class="{'disabled': current_step==104}"><i class="fa fa-angle-down"></i></button>
                        </div> -->
        </div>
      </b-row>
    </b-container>

    <b-modal ref="forget-popup" hide-footer id="forgetpopup" header-text-variant="light" header-border-variant="none">
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img src="footer-logo.png" alt="" />
            <h4 class="mt-4 mb-3">Forget Passoword</h4>
          </b-col>

          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input placeholder="Enter Email" v-model="forget_user_email" type="text" autocomplete="on"
                class="position-relative pr-30 hight50">
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(forget_user_email)" class="fas fa-times text-danger"></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>

          <b-form-group class="text-center mt-2">
            <b-col class="d-flex align-items-center">
              <b-button class="btn btn-success theme-color-btn w-100 btnheight50" @click="forgetNow()"
                :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)" aria-controls="cust-core-expense-1">
                Send link on email
              </b-button>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style>
#app_steps nav#navbar {
  display: none;
}

#app_steps .user-detail a {
  display: block;
  margin: 0 auto;
}

#app_steps .user-detail a img {
  left: initial;
  transform: initial;
  -webkit-transform: initial;
}

.darkmode .text-light span {
  color: #fff;
}

.custom-switch-step-style {
  position: fixed;
  right: 15px;
  top: 10px;
  z-index: 999;
}

/* #app_steps a.backhome {
    left: 0;
} */

.inputGroup {
  background-color: #fdfdfd;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  display: block;
  width: 100%;
  position: relative;
}

@media (max-width: 991px) {
  .manually-inputGroup-radios {
    display: grid;
    grid-template-columns: 50% auto;
    gap: 10px;
  }

  .inputGroup {
    margin: 4px 0;
  }

  .gross-net-home-radios,
  .income-method-type {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 10px;
  }
}

@media (max-width: 575px) {

  .gross-net-home-radios,
  .income-method-type,
  .manually-inputGroup-radios {
    display: block;
  }
}

.darkmode .inputGroup {
  background-color: #090a0b;
  border: 1px solid #43495a;
}

.inputGroup label {
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  margin-bottom: 0;
  width: 100%;
  display: block;
  text-align: left;
  color: #3c454c;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: color 0.2s ease-in;
  -webkit-transition: color 0.2s ease-in;
  -moz-transition: color 0.2s ease-in;
  -o-transition: color 0.2s ease-in;
  overflow: hidden;
}

.darkmode .inputGroup label {
  color: #d0d2e8;
}

.inputGroup label:before {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  content: "";
  background-color: #235d37;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scaleX(1);
  -webkit-transform: translate(-50%, -50%) scaleX(1);
  -moz-transform: translate(-50%, -50%) scaleX(1);
  -o-transform: translate(-50%, -50%) scaleX(1);
  -webkit-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -moz-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  z-index: -1;
}

.inputGroup label:after {
  width: 24px;
  height: 24px;
  content: "";
  border: 2px solid #a5a5a5;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: -2px 0;
  border-radius: 50%;
  z-index: 2;
  position: absolute;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  background-image: none;
}

.inputGroup input:checked~label:after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='32' height='32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff'/%3E%3C/svg%3E");
}

.darkmode .inputGroup label:after {
  background-color: #212329;
  border: 1px solid #787c86;
}

.inputGroup input:checked~label {
  color: #fff;
}

.inputGroup input:checked~label:before {
  transform: translate(-50%, -50%) scale3d(56, 56, 1);
  -webkit-transform: translate(-50%, -50%) scale3d(56, 56, 1);
  -moz-transform: translate(-50%, -50%) scale3d(56, 56, 1);
  -o-transform: translate(-50%, -50%) scale3d(56, 56, 1);
  opacity: 1;
}

.inputGroup input:checked~label:after {
  background-color: #54e0c7;
  border-color: #54e0c7;
}

.inputGroup input {
  width: 28px;
  height: 28px;
  -webkit-box-ordinal-group: 2;
  -ms-flex-order: 1;
  order: 1;
  z-index: 2;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  cursor: pointer;
  visibility: hidden;
}

.total_monthly_inc {
  font-size: 18px;
  font-weight: 700;
  text-align: right;
  color: #000;
  margin: 10px 0;
}

@media (max-width: 767px) {
  .total_monthly_inc {
    font-size: 14px;
  }

  .total_monthly_inc .income-amount {
    font-size: 18px;
  }
}

.monthly-gross-income-inner-card {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.income-method-type .inputGroup label,
.manually-input-radios .inputGroup label {
  font-size: 14px;
  font-weight: 500;
}

.darkmode .monthly-gross-income-inner-card {
  background-color: #151d32;
  border: 1px solid #43495a !important;
}

.result-profile-innercard {
  box-shadow: none !important;
  border: 1px solid #000 !important;
}

.result-profile-innercard-body,
.result-profile-innercard-header {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
}

.darkmode .profile-innercard {
  background-color: #292f45 !important;
  border: 1px solid #525b75 !important;
}

.result-profile-innercard-header {
  border-bottom: 1px solid #e3e8f5;
}

.darkmode .result-profile-innercard-header {
  border-bottom: 1px solid #525b75 !important;
}

.monthly-net-amount {
  background-color: #efe2f8;
  border-radius: 6px !important;
  padding: 6px !important;
  display: block;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  color: #6e2c98 !important;
  border: 2px solid #6e2c98 !important;
}

/* .result-profile-card .card-body {
    padding: .6rem
} */
.darkmode .profile-innercard-title {
  color: #d0d2e8;
}

.profile-innercard-title {
  font-size: 16px;
  color: #3a3a3a;
  margin: 0;
  font-weight: 700;
}

@media (min-width: 1366px) {
  .profile-innercard-title {
    font-size: 17px;
  }
}

.darkmode .result-profile-card {
  background-color: #2a2f3b !important;
  border: 1px solid #43495a !important;
}

.darkmode .profile-innercard {
  background-color: #2a2f3b !important;
  border: 1px solid #525b75 !important;
}

.profile-innercard .income-method-inner {
  border-radius: 0.25rem;
}

.darkmode .profile-innercard .income-method-inner {
  background-color: #43495a;
  border: 1px solid #596179;
  padding: 10px;
}

.result-profile-innercard-actions .btn {
  font-weight: 700;
}

.result-profile-innercard-actions .btn:after {
  display: none;
}

.darkmode .total_monthly_inc {
  color: #d0d2e8;
}

.total_monthly_inc span {
  display: inline-block;
  width: 120px;
  margin-left: 10px;
  background-color: #dffbf8;
  color: #2ba195;
  border-radius: 6px;
  padding: 2px 10px;
  text-align: center;
  border: 1px solid #c4ede9;
}

.annual-gross-input .form-group input::placeholder {
  opacity: 0;
}

.annual-gross-input .form-group input::-ms-input-placeholder {
  opacity: 0;
}

.city-state {
  position: absolute;
  display: flex;
  justify-content: space-around;
  width: 50%;
  right: 0px;
  top: 22px;
  color: rgb(135, 135, 135);
  font-size: 20px;
}

@media only screen and (max-width: 820px) {
  .city-state {
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  .total_monthly_inc span {
    display: block;
    width: 100%;
    margin-left: 0;
    margin-top: 5px;
  }
}

.ai-response-profile-card-body h2,
.occupation-hover-info h2 {
  margin-bottom: 0;
  margin-left: -15px;
  margin-right: -15px
}

.ai-response-profile-card-body h2:first-of-type,
.darkmode .ai-response-profile-card-body h2:first-of-type,
.darkmode .occupation-hover-info h2:first-of-type,
.occupation-hover-info h2:first-of-type {
  border-top: 1px solid transparent
}

.ai-response-profile-card-header h2 {
  font-size: 18px;
  margin-bottom: 0
}

.occupation-hover-info h2 {
  font-size: 16px
}

.ai-response-profile-card-header h2,
.occupation-hover-info h2 {
  font-weight: 600;
  color: #e8ae4d;
}

.ai-response-profile-card-header h2 {
  border-bottom: 1px solid rgba(0, 0, 0, .125);
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px
}

.ai-response-profile-card-body h2:first-of-type,
.occupation-hover-info h2:first-of-type {
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  margin-bottom: 0
}

.ai-response-profile-card-header h2,
.occupation-hover-info h2 {
  border-bottom: 1px solid #eee
}

.darkmode .ai-response-profile-card-header h2,
.darkmode .occupation-hover-info h2 {
  border-bottom: 1px solid #525b75
}

.ai-response-profile-card-body-content {
  margin-bottom: 20px
}

.ai-response-profile-card-body .ai-response-profile-card-body-content:last-child {
  margin-bottom: 0
}

.ai-response-profile-card-body h3,
.occupation-hover-info h3 {
  font-weight: 600;
  color: #292929
}

.occupation-hover-info h3 {
  font-size: 14px
}

.ai-response-profile-card-body h3 {
  font-size: 16px;
  margin-bottom: 5px
}

.occupation-hover-info {
  font-size: 13px
}

.darkmode .ai-response-profile-card-body h3,
.darkmode .occupation-hover-info h3 {
  color: #d0d2e8
}

.ai-response-profile-card-body li::marker,
.occupation-hover-info li::marker {
  color: #3f51b5
}

.ai-response-min-height {
  min-height: 568px
}

.ai-response-max-height {
  max-height: 568px;
  overflow-y: auto;
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: 5px
}

.ai-overflow-y::-webkit-scrollbar-track,
.navigation-area::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #eee;
  border-radius: 30px
}

.ai-overflow-y::-webkit-scrollbar,
.navigation-area::-webkit-scrollbar {
  width: 6px;
  background-color: #eee;
  border-radius: 30px
}

.ai-overflow-y::-webkit-scrollbar-thumb,
.navigation-area::-webkit-scrollbar-thumb {
  background-color: #987e4c;
  border-radius: 30px
}

.ai-response-profile-card-body,
.budget-health-score-card-body,
.budget-health-score-card-footer,
.budget-health-score-card-header,
.result-profile-innercard-body,
.result-profile-innercard-footer,
.result-profile-innercard-header {
  padding-left: 15px;
  padding-right: 15px
}

@media (max-width: 1442px) {

  .budget-health-score-card-footer,
  .budget-health-score-card-header,
  .result-profile-card .result-profile-innercard-body,
  .result-profile-innercard-footer,
  .result-profile-innercard-header {
    padding-left: 10px;
    padding-right: 10px
  }
}

@media (max-width: 991px) {
  .income-method-inner .result-profile-innercard {
    width: 100% !important
  }

  .income-method-inner {
    padding: 0 !important;
    margin: 0 !important
  }

  .budget-health-score-card-footer,
  .budget-health-score-card-header,
  .profile-innercard .card-body,
  .result-profile-innercard-body,
  .result-profile-innercard-footer,
  .result-profile-innercard-header {
    padding-left: 15px;
    padding-right: 15px
  }

  .xs-mt-2 {
    margin-top: 10px
  }
}

.ai-response-profile-card-body,
.budget-health-score-card-body,
.budget-health-score-card-footer,
.budget-health-score-card-header,
.result-profile-innercard-body,
.result-profile-innercard-footer,
.result-profile-innercard-header {
  padding-top: 10px;
  padding-bottom: 10px
}
.darkmode .steps-body .ai-response-profile-card-header h2, 
.darkmode .steps-body .occupation-hover-info h2 {
    font-weight: 600;
    color: #eabc6b;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
